import { formatCurrency, getItemFromStorage } from "./script";
import { atpProvidersOptions, carrierTypeOptionById, carrierTypesOptions, frontendOptions, gdqStatusOptions, insideClinicOptions, liabilityPolicyLimitsOptions, liabilityPolicyStatusOptionsPayerTypes, majorMedPolicyStatusOptionsPayerTypes, medPayMPPolicyStatusOptionsPayerTypes, medPayPIPPolicyStatusOptionsPayerTypes, medPayPolicyLimitsOptions, MRQStatusesOptions, outsideClinicOptions, resolveAttorneyStatusOption, treatmentStatusesOptions, umPolicyStatusOptionsPayerTypes } from "./systemData";

function asNumericValue(value) {
    if (value == null || value === '') return null
    if (typeof value === 'number') return Number.isFinite(value) ? value : null
    const normalized = `${value}`.replace(/,/g, '').trim()
    if (!normalized) return null
    const parsed = Number(normalized)
    return Number.isFinite(parsed) ? parsed : null
}

function formatPolicyLimitValue(value) {
    const numericValue = asNumericValue(value)
    if (numericValue == null) return null
    let formatted = `${formatCurrency(numericValue)}`
    // Remove trailing .00 if present (e.g. 25,000.00 -> 25,000)
    if (formatted.endsWith('.00')) {
        formatted = formatted.slice(0, -3)
    }
    return `$${formatted}`
}

export function getAppointmentStatusLabel(status) {
    if (status == null || String(status).trim() === '') return 'Expected'
    if (String(status).trim().toLowerCase() === 'default') return 'Expected'
    return status
}

export function getCaseStatusFromId(caseStatusId) {
    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.case_statuses) {
        let item = systemSettings.case_statuses.find(item => item.id == caseStatusId)

        if (item) {
            return item.name
        }
        return null
    }

    return null
}

export function getCaseTypeFromId(caseTypeId) {
    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.case_types) {
        let item = systemSettings.case_types.find(item => item.id == caseTypeId)

        if (item) {
            return item.name
        }
        return null
    }

    return null
}

export function getCaseLevelFromId(caseLevelId) {
    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.case_levels) {
        let item = systemSettings.case_levels.find(item => item.id == caseLevelId)

        if (item) {
            return item.name
        }
        return null
    }

    return null
}

export function getCaseSourceFromId(caseSourceId) {
    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.case_sources) {
        let item = systemSettings.case_sources.find(item => item.id == caseSourceId)

        if (item) {
            return item.name
            // return item.full_name ? item.full_name : item.name
        }
        return null
    }

    return null
}
export function getCaseSourceFullNameFromId(caseSourceId) {
    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.case_sources) {
        let item = systemSettings.case_sources.find(item => item.id == caseSourceId)

        if (item) {
            // return item.name
            return item.full_name
        }
        return null
    }

    return null
}

export function getLiabilityPolicyLimitsLabel(policyLimit) {
    const numericValueLabel = formatPolicyLimitValue(policyLimit)
    if (numericValueLabel) {
        return numericValueLabel
    }

    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.liability_policy_limits) {
        let item = systemSettings.liability_policy_limits.find(item => item.id == policyLimit)

        if (item) {
            return item.name
        }
        return null
    }

    return null
}

export function getUmPolicyLimitsLabel(policyLimit) {
    const numericValueLabel = formatPolicyLimitValue(policyLimit)
    if (numericValueLabel) {
        return numericValueLabel
    }

    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.um_policy_limits) {

        let item = systemSettings.um_policy_limits.find(item => item.id == policyLimit)

        if (item) {
            return item.name
        }
        return null
    }

    return null
}

export function getUmPolicyLimitsAmount(policyLimit) {
    const numericValue = asNumericValue(policyLimit)
    if (numericValue != null) {
        return formatCurrency(numericValue)
    }

    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.um_policy_limits) {

        let item = systemSettings.um_policy_limits.find(item => item.id == policyLimit)

        if (item) {
            return item.amount_patient ? formatCurrency(item.amount_patient) : 0
        }
        return null
    }

    return null
}

export function getUMPolicyStatusLabel(Id) {
    if (umPolicyStatusOptionsPayerTypes()) {

        let item = umPolicyStatusOptionsPayerTypes().find(item => item.value == Id)

        if (item) {
            return item.label
        }
        return null
    }

    return null
}

export function getMedPayPolicyLimitsLabel(policyLimit) {
    const numericValueLabel = formatPolicyLimitValue(policyLimit)
    if (numericValueLabel) {
        return numericValueLabel
    }

    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.med_pay_policy_limits) {
        let item = systemSettings.med_pay_policy_limits.find(item => item.id == policyLimit)

        if (item) {
            return item.name
        }
        return null
    }

    return null
}
export function getMedPayPolicyStatusLabel(Id) {
    if (medPayPIPPolicyStatusOptionsPayerTypes()) {
        let item = medPayPIPPolicyStatusOptionsPayerTypes().find(item => item.value == Id)

        if (item) {
            return item.label
        }
        return null
    }

    return null
}

export function getMedPayPolicyStatusLabelMP(Id) {
    if (medPayMPPolicyStatusOptionsPayerTypes()) {
        let item = medPayMPPolicyStatusOptionsPayerTypes().find(item => item.value == Id)

        if (item) {
            return item.label
        }
        return null
    }

    return null
}



export function getPracticeNameFromId(Id) {
    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.practices) {
        let item = systemSettings.practices.find(item => item.id == Id)

        if (item) {
            return item.short_name ? item.short_name : item.name
        }
        return null
    }

    return null
}

export function getLiabilityPolicyStatusLabel(id) {

    let options = frontendOptions()?.assumedOptions
    if (options && id !== null) {
        let item = options.find(item => item.value == id)

        if (item) {
            return item.label
        }
        return null
    }
}

export function getPolicyStatusNameFromId(Id) {
    if (liabilityPolicyStatusOptionsPayerTypes()) {
        let item = liabilityPolicyStatusOptionsPayerTypes().find(item => item.value == Id)

        if (item) {
            return item.label
        }
        return null
    }

    return null
}

export function getLocationNameFromId(Id) {
    const systemSettings = getItemFromStorage('settings')

    if (systemSettings && systemSettings.practices) {
        let allLocations = []

        systemSettings.practices.forEach(element => {
            if (element.locations) {
                allLocations = [...allLocations, ...element.locations]
            }
        });

        let item = allLocations.find(item => item.id == Id)

        if (item) {
            return item.code //{/* display_name */}
        }
        return null
    }

    return null
}




export function returnUMTypeLabel(id) {
    if (id != null) {
        const fields = frontendOptions()?.umTypeRadioFields
        if (Array.isArray(fields)) {
            const item = fields.find((item) => item.value == id)
            if (item) {
                return item.label
            }
        }
    }
    return null
}

export function getWorkerCompStatusLabel(statusId) {
    if (frontendOptions()?.workersCompStatus) {
        let item = frontendOptions()?.workersCompStatus.find(item => item.value == statusId)

        if (item) {
            return item.label
        }
        return null
    }

    return null
}

export function getPolicyLimtsText(value) {
    const numericValueLabel = formatPolicyLimitValue(value)
    if (numericValueLabel) {
        return numericValueLabel
    }

    let options = liabilityPolicyLimitsOptions()
    if (options) {
        let foundItem = options.find(item => item.value == value)

        if (foundItem) {
            return foundItem.label
        } 

        return null
    }

    return null
}

export function getMajorMedCarrierTypeText(value) {
    let options = carrierTypesOptions()
    if (options) {
        let textArr = []
        if (value && value.length>0) {
            value.forEach(element => {
                let foundItem = options.find(item => item.value == element)
                if (!foundItem) {
                    foundItem = carrierTypeOptionById(element)
                }

                if (foundItem) {
                    const inactiveSuffix = foundItem.isDisabled ? ' (Inactive)' : ''
                    textArr.push(`${foundItem.label}${inactiveSuffix}`)
                }
            });
        }

        if (textArr.length > 0) {
            return textArr.join(', ')
        } 

        return null
    }

    return null
}

export function getMajorMedPolicyStatusText(value) {
    let options = majorMedPolicyStatusOptionsPayerTypes()
    if (options) {
        let foundItem = options.find(item => item.value == value)

        if (foundItem) {
            return foundItem.label
        } 

        return null
    }

    return null
}




export function getTreatmentStatusLabelFromId(id) {
    let options = treatmentStatusesOptions()
    if (id && options) {
        return options.find(item => item.value == id)?.label
    }

    return null
}

export function getMRQStatusLabelFromId(id) {
    let options = MRQStatusesOptions()
    if (id && options) {
        return options.find(item => item.value == id)?.label
    }

    return null
}

export function getAttyStatusFromId(id) {
    return resolveAttorneyStatusOption(id, true)?.label ?? null
}

export function getWholeAttyStatusFromId(id) {
    return resolveAttorneyStatusOption(id, true) ?? null
}


export function getLiabilityStatusFromId(id) {
    let options = frontendOptions()?.assumedOptions

    if (id && options) {
        return options.find(item => item.value == id)?.label
    }

    return null
}


export function getinsideClinicNameFromPracticeId(practiceId) {
    let options = insideClinicOptions()

    if (practiceId && options) {
        return options.find(item => item.value == practiceId)?.label
    }

    return null
}

export function getinsideClinicNameFromOutsideLocationId(locId) {
    let options = outsideClinicOptions()

    if (locId && options) {
        return options.find(item => item.value == locId)?.label
    }

    return null
}

export function getAtpProviderNameFromProviderId(practiceId) {
    let options = atpProvidersOptions()

    if (practiceId && options) {
        return options.find(item => item.value == practiceId)?.label
    }

    return null
}

export function getGDQStatusNameFromId(gdq_status_id) {
    let options = gdqStatusOptions()
    if (gdq_status_id && options) {
        return options.find(item => item.value == gdq_status_id)?.label
    }

    return null
}


export function getStatusOfInsurance(insurance, type) {
    if (insurance && type) {
        switch (type) {
            case 'liability':
                return getPolicyStatusNameFromId(insurance.policy_status)
            case 'um':
                return getUMPolicyStatusLabel(insurance.um_status)
            case 'mp':
                return getMedPayPolicyStatusLabelMP(insurance.mp_status)
            case 'pip':
                return getMedPayPolicyStatusLabel(insurance.pip_status)
            case 'majormed':
                return getMajorMedPolicyStatusText(insurance.policy_status)
            default:
                break;
        }
    }

    return null
}

export function getSurgicalStatus(status) {
    if (status && frontendOptions()?.surgeryRecomandation) {
        let found = frontendOptions()?.surgeryRecomandation.find(item => item.value == status)?.label

        return found
    }

    return null
}

export function getSurgeryApprovalStatus(status) {
    if (status && frontendOptions()?.surgeryApprovalStatus) {
        let found = frontendOptions()?.surgeryApprovalStatus.find(item => item.value == status)?.label

        return found
    }

    return null
}